import { Button } from 'antd';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import HeaderTop from '../HeaderTopFurusato';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public styles: React.CSSProperties = { paddingTop: '50px' };
  public render() {
    if (this.state.hasError) {
      return (
        <div className="text-center">
          <HeaderTop />
          <h1 style={this.styles}>Sorry.. there was an error</h1>
          <Button>
            <a href="top">Back to Home</a>
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
